import useSeoPage from '../../hooks/useSeoPage';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import DoctorsSection from './components/DoctorsSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

  useSeoPage({
    title: 'Zimbet32 - Clinică stomatologică în Chișinău | Stomatologie modernă',
    description: 'Zimbet32 — современная стоматологическая клиника в Кишинёве. Терапевтическая, ортопедическая стоматология, хирургия, имплантация. Профессиональные врачи и технологии европейского уровня.',
    keywords: 'стоматология Кишинёв, стоматолог Кишинёв, имплантация зубов, протезирование зубов, лечение зубов, Stomatologie Chișinău, stomatolog Chișinău, implant dentar, protezare dentară, Zimbet32',
    canonicalPath: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Dentist',
        name: 'Zimbet32',
        url: siteUrl,
        image: 'https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/4595d76c80b5322e477f2894d2f3301b.png',
        description: 'Zimbet32 — современная стоматологическая клиника в Кишинёве. Терапевтическая, ортопедическая стоматология, хирургия, имплантация.',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Strada București 60',
          addressLocality: 'Chișinău',
          postalCode: 'MD-2012',
          addressCountry: 'MD',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 47.019338,
          longitude: 28.831757,
        },
        telephone: '+373-22-22-07-09',
        email: 'zimbet32@mail.ru',
        priceRange: '$$',
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '18:00',
          },
        ],
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Стоматологические услуги',
          itemListElement: [
            { '@type': 'Offer', itemOffered: { '@type': 'MedicalProcedure', name: 'Терапевтическая стоматология' } },
            { '@type': 'Offer', itemOffered: { '@type': 'MedicalProcedure', name: 'Ортопедическая стоматология' } },
            { '@type': 'Offer', itemOffered: { '@type': 'MedicalProcedure', name: 'Хирургическая стоматология' } },
            { '@type': 'Offer', itemOffered: { '@type': 'MedicalProcedure', name: 'Имплантация зубов' } },
            { '@type': 'Offer', itemOffered: { '@type': 'MedicalProcedure', name: 'Ортодонтия' } },
            { '@type': 'Offer', itemOffered: { '@type': 'MedicalProcedure', name: 'Профилактика и гигиена' } },
          ],
        },
        sameAs: [],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: siteUrl,
        name: 'Zimbet32',
        description: 'Clinică stomatologică modernă în Chișinău',
        inLanguage: ['ru', 'ro'],
      },
    ],
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <DoctorsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;